import { Skeleton } from "@mui/material";
import { Button, Card, Grid2, Typography } from "components";
import { Edit1Icon } from "components/Icons";
import { Fragment, useState } from "react";
import DetailsModal from "./DetailsModal";

interface Props {
  data: any;
  isLoading: boolean;
}

const detailFields = [
  { name: "SEBI Number", key: "sebiNumber" },
  { name: "GST", key: "gst" },
  { name: "Address", key: "address" },
  { name: "Country", key: "country" },
  { name: "State", key: "state" },
  { name: "City", key: "city" },
  { name: "Pincode", key: "pincode" },
];

const Details = (props: Props) => {
  const { data, isLoading } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Grid2 container spacing={1}>
      {detailFields.map((field) => (
        <Fragment key={field.key}>
          <Grid2 size={2.8}>
            <Card
              sx={{ p: 1.5, height: "100%", background: "var(--neutral-50)" }}
            >
              <Typography fontSize={12} fontWeight={500}>
                {field.name}:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
                sx={{ wordBreak: "break-word" }}
              >
                {isLoading ? (
                  <Skeleton width="60%" />
                ) : (
                  data?.[field.key] || "-"
                )}
              </Typography>
            </Card>
          </Grid2>
          {field.key === "country" && (
            <Grid2 container justifyContent="flex-end" alignItems="center">
              <Button
                variant="secondaryDark"
                onClick={() => setIsModalOpen(true)}
                disabled={isLoading}
              >
                <Edit1Icon fontSize="small" />
              </Button>
            </Grid2>
          )}
        </Fragment>
      ))}

      {isModalOpen && (
        <DetailsModal open={isModalOpen} setOpen={setIsModalOpen} data={data} />
      )}
    </Grid2>
  );
};

export default Details;
